import { render, staticRenderFns } from "./FbRadioButtonView.vue?vue&type=template&id=1b070890"
import script from "./FbRadioButtonView.vue?vue&type=script&lang=js"
export * from "./FbRadioButtonView.vue?vue&type=script&lang=js"
import style0 from "./FbRadioButtonView.vue?vue&type=style&index=0&id=1b070890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports